var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBaloonSmall = function SvgBaloonSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 57,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5562CE",
    d: "M56.181 26.951a28.16 28.16 0 0 0-36.27-25.75 27.3 27.3 0 0 0-18.71 18.7 28.38 28.38 0 0 0 21.62 36c.21 0 .5.11.72.14.618.106 1.244.16 1.87.16h29.41a3 3 0 0 0 2.23-4.94l-1-1.08a6.1 6.1 0 0 1-1.44-3 8.2 8.2 0 0 1 0-3.16 71.2 71.2 0 0 0 1.55-17.13z",
    opacity: 0.8
  })));
};
export default SvgBaloonSmall;